import React from 'react';
import { CheckIcon, GiftIcon, LightbulbIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-label="Exclusive bonuses" data-id="element-68" data-mp="autf33atstue">
      <div className="mx-auto max-w-5xl" data-id="element-69" data-mp="fsv6qcmbi1hh">
        <SectionHeading kicker="5 exclusive bonuses — included free" title={<>
              Get these five resources <span className="text-amber" data-id="element-71" data-mp="5x1lm4uj8zo3">with your purchase</span>
            </>} subtitle="Complementary resources that make the Blueprint easier to use in everyday diagnostic work." data-id="element-70" data-mp="1uer1w6h90n7" />

        <div className="space-y-14" data-id="element-72" data-mp="3t1835v2t6k6i">
          {bonuses.map(b => <article key={b.number} className="md:grid md:grid-cols-2 md:items-center md:gap-10" data-id="element-73" data-mp="1m9ywzejj2yyl">
              <div className="-mx-4 md:mx-0" data-id="element-74" data-mp="1r9la7nzcwf7e">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full md:rounded-2xl" loading="lazy" data-id="element-75" data-mp="1r78snbxig6uv" />
              </div>

              <div className="mt-6 md:mt-0" data-id="element-76" data-mp="3r6i5mvh7vb7y">
                <div className="flex flex-wrap items-center gap-3" data-id="element-77" data-mp="3r68f96s9f21q">
                  <span className="inline-flex items-center gap-1.5 rounded-lg bg-signal px-3 py-1.5 font-display text-lg font-extrabold uppercase text-white" data-id="element-78" data-mp="3n4wkkmuj3qmo">
                    <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="2zhf0ldhi9wu9" />
                    Bonus #{b.number}
                  </span>
                  <span className="text-[15px] font-semibold text-mist" data-id="element-80" data-mp="38gs3fnb4jn60">
                    Value <s className="text-mist" data-id="element-81" data-mp="33hff0y4lu81b">${b.value}</s> — <span className="font-extrabold text-ok" data-id="element-82" data-mp="33ge3ytnl9ljl">FREE</span>
                  </span>
                </div>
                <h3 className="mt-3 font-display text-3xl font-extrabold uppercase leading-none text-white sm:text-4xl" data-id="element-83" data-mp="no6opgf0j2m8">
                  {b.title}
                </h3>
                <p className="mt-3 text-[16px] leading-relaxed text-mist" data-id="element-84" data-mp="3chv3nlqtb4kj">{b.description}</p>
                <ul className="mt-4 space-y-2" data-id="element-85" data-mp="3hh808y7hjq0b">
                  {b.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-white" data-id="element-86" data-mp="3ljcsptm76gld">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-87" data-mp="3qj7ghoaoeq27" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 flex items-start gap-3 rounded-xl bg-panel p-4 text-[15px] leading-relaxed text-white" data-id="element-88" data-mp="2xt8rtu0e8uy2">
                  <LightbulbIcon className="mt-0.5 h-5 w-5 shrink-0 text-amber" aria-hidden="true" data-id="element-89" data-mp="32rjzpz74ovdn" />
                  <span data-id="element-90" data-mp="37legatrfsu8i">
                    <strong className="text-amber" data-id="element-91" data-mp="37lo7gko7x7fs">Why it’s useful:</strong> {b.why}
                  </span>
                </p>
              </div>
            </article>)}
        </div>

        <CtaButton className="mt-14" label="Claim my 5 free bonuses" sub="Bonuses included with your $27 purchase" data-id="element-92" data-mp="2f1fujneaknkj" />
      </div>
    </section>;
}